import axios from 'axios';
import router from '../../router/index.js';
import { Message } from 'element-ui';

//开元正式
const baseURL = 'http://platapi.vcjiayan.com/';
//测试地址
//const baseURL = 'http://kaiyuantianhui.vue.waiwubang.com/prod-api/';
//const baseURL = 'http://localhost:9003/';
axios.defaults.withCredentials = true;

export function getUrl(rr) {
    return baseURL + rr;
}

export function getCodeImg() {
    return getRequest('captchaImage1');
}



// post请求
async function postRequest(url, data) {
    let token = '';
    if (localStorage.token) {
        token = localStorage.token;
    }

    let res = await axios.post(getUrl(url), data, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: token
        }
    });

    if (res.data.code == 200) {
        return Promise.resolve(res.data);
    } else if (res.data.code == 201) {
        return Promise.resolve(res.data);
    } else if (res.data.code == 401) {
        router.push('/login');
    } else if (res.data.code == 500) {
        if (data.Promise) {
            return Promise.resolve(res.data);
        } else {
            if (res.data.msg) {
                Message.error(res.data.msg);
            }
        }
    } else {
        console.log('-------------接口请求错误------------');
        console.log(res);
        console.log('-------------接口请求错误------------');
    }
    return Promise.resolve(undefined);
}

async function postRequest2(url, data) {
    let res = await axios.post(getUrl(url), data, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
    if (res.data.code == 200) {
        return Promise.resolve(res.data);
    } else if (res.data.code == 201) {
        return Promise.resolve(res.data);
    } else if (res.data.code == 401) {
        router.push('/login');
    } else if (res.data.code == 500) {
        if (res.data.msg) {
            Message.error(res.data.msg);
        }
    } else {
        console.log('-------------接口请求错误------------');
        console.log(res);
        console.log('-------------接口请求错误------------');
    }
    return Promise.resolve(undefined);
}

// get请求
async function getRequest(url) {
    let token = localStorage.token || '';

    let res = await axios.get(getUrl(url), {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: token
        }
    });

    if (res.data.code == 200) {
        return Promise.resolve(res.data);
    } else if (res.data.code == 401) {
        router.push('/login');
    } else if (res.data.code == 500) {
        if (res.data.msg) {
            Message.error(res.data.msg);
        }
    } else {
        console.log('-------------接口请求错误------------');
        console.log(res);
        console.log('-------------接口请求错误------------');
    }
    return Promise.resolve(undefined);
}


async function getRequest2(url) {
    let res = await axios.get(getUrl(url), {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    });
    console.log(res);
    if (res.status == 200) {
        return Promise.resolve(res.data);
    } else {
        console.log('-------------接口请求错误------------');
        console.log(res);
        console.log('-------------接口请求错误------------');
    }
    return Promise.resolve(undefined);
}


// 1.登录
export const loginRequest = (data) => {
    return postRequest('login-customer', data);
};

// 2.站点baseInfo
export const baseInfoRequest = (url) => {
    return getRequest('api/daifa/config/info/' + url);
};

export const cityRequest = (t) => {
    return getRequest2('api/daifa/config/cityinfo/' + t);
};

export const getKeysRequest = (data) => {
    return postRequest('api/config/getKeys', data);
};

// 3.获取购物车数量信息
export const shoppingCarNumber = () => {
    return getRequest('api/cart/count');
};

// 4.申请开票
export const applyGetOrderRequest = (data) => {
    return postRequest('api/invoice/insert', data);
};

// 5.获取付款账户列表
export const payAccountInfoRequest = () => {
    return getRequest('api/account/list');
};

// 6.上传图片请求
export const upLoadImgRequest = (data) => {
    return postRequest('api/file/upload', data);
};

// 7.线下充值申请请求
export const lineDownPayApplyRequest = (data) => {
    return postRequest('api/financial/offlineRecharge/add', data);
};

// 8.线下充值记录请求
export const lineDownPayRecordRequest = (data) => {
    return postRequest('api/financial/offlineRecharge/record/list', data);
};

// 9.每月对账单记录请求
export const everyMonthRecordRequest = (data) => {
    return postRequest('api/accountStatement/list', data);
};

// 10.余额变更记录请求
export const leftMoneyChangeRecordRequest = (data) => {
    return postRequest('api/financial/balanceChange/record/list', data);
};

// 11.开票信息管理记录请求
export const openOrderInfoManageRecordRequest = (data) => {
    return postRequest('api/invoice/list', data);
};

// 12.删除开票信息请求
export const DeteleOpenOrderInfoRecordRequest = (url) => {
    return getRequest('api/invoice/delete/' + url);
};

// 13.线上充值记录请求
export const lineUpPayRecordRequest = (data) => {
    return postRequest('api/financial/onlineRecharge/list', data);
};

// 14.修改密码请求
export const changePasswordRequest = (data) => {
    return postRequest('api/profile/updatePwd', data);
};

// 15.获取用户基本信息请求
export const getUserBaseInfoRequest = () => {
    return getRequest('api/profile/info');
};

// 16.商品详情请求
export const goodsDetailRequest = (url) => {
    return getRequest('api/goods/' + url);
};

// 16.查询库存
export const getGoodStockRequest = (data) => {
    return postRequest('api/goods/getGoodStock',data);
};

// 17.售后商品详情请求
export const saledGoodsDetailRequest = (url) => {
    return getRequest('api/after/sales/' + url);
};

export const returnOrderDetailRequest = (url) => {
    return getRequest('api/sales/return/' + url);
};


// 18.加入购物车请求
export const addShppingCarRequest = (data) => {
    return postRequest('api/insert/goods/tocart', data);
};

// 18.加入购物车请求
export const addCartRequest = (data) => {
    return postRequest('api/cart/add', data);
};
export const editCartRequest = (data) => {
    return postRequest('api/cart/edit', data);
};
export const delCartRequest = (data) => {
    return postRequest('api/cart/delete', data);
};
export const clearCartRequest = (data) => {
    return postRequest('api/cart/clear', data);
};

// 19.商品列表详情请求
export const goodsListRequest = (data) => {
    return postRequest('api/goods/list2', data);
};

// 20.商品分类列表详情请求
export const goodsCateListRequest = (url) => {
    return getRequest('api/goods/types' + url);
};

// 21.商品价格分类列表详情请求
export const goodsPriceCateListRequest = (url) => {
    return getRequest('api/goods/price/list' + url);
};

// 22.导出请求
export const exportReequest = (url) => {
    return getRequest(url);
};

export const exportOrderReequest = (data) => {
    return postRequest('api/order/export', data);
};

export const exportOrderIndeliveryReequest = (data) => {
    return postRequest('api/order/export/indelivery', data);
};

export const exportOrderDeliveredReequest = (data) => {
    return postRequest('api/order/export/delivered', data);
};

export const exportSetmealReequest = (data) => {
    return postRequest('api/setmeal/export', data);
};


// 23.公共套餐列表数据请求
export const publicTCListRequest = (data) => {
    return postRequest('api/public/meal/list', data);
};

// 24.全部订单请求
export const allOrderListRequest = (data) => {
    return postRequest('api/order/list', data);
};

// 25.取消订单请求
export const cacelOrderRequest = (url) => {
    return getRequest('api/order/cencel/' + url);
};

export const toQ3OrderRequest = (data) => {
    return postRequest('api/order/toQ3', data);
};

export const cacelsOrderRequest = (data) => {
    return postRequest('api/order/cacels', data);
};

export const cancelOrderRequest = (data) => {
    return postRequest('api/order/cancels', data);
};


export const deleteOrderRequest = (url) => {
    return getRequest('api/order/delete/' + url);
};

export const deletesOrderRequest = (data) => {
    return postRequest('api/order/deletes', data);
};

// 26.全部导入订单请求
export const allIntoedOrderListRequest = (data) => {
    return postRequest('api/batch/list', data);
};

// 27.取消导入订单请求
export const cacelIntoedOrderRequest = (url) => {
    return getRequest('api/delete/order/an/' + url);
};

// 28.上传导入订单请求
export const upLoadOrderRequest = (data) => {
    let nn = '';
    if (localStorage.username) {
        nn = localStorage.username || '';
    }
    if (nn == '') {
        if (localStorage.userInfo) {
            nn = localStorage.username || '';
            let bb = JSON.parse(localStorage.userInfo);
            if (bb) {
                nn = bb.customerName;
            }
        }
    }
    if (nn != 'dz' || nn == '测试-客户' || nn == '莱芜辰龙贸易有限公司') {
        return postRequest('api/order/import', data);
    }
    return postRequest('api/import/excel', data);
};

// 29.确认导入订单请求
export const submitUpLoadOrderRequest = (data) => {
    return postRequest('api/order/insert', data);
};

export const orderInsertsRequest = (data) => {
    let nn = '';
    if (localStorage.username) {
        nn = localStorage.username || '';
    }
    if (nn == '') {
        if (localStorage.userInfo) {
            nn = localStorage.username || '';
            let bb = JSON.parse(localStorage.userInfo);
            if (bb) {
                nn = bb.customerName;
            }
        }
    }
    if (nn != 'dz' || nn == '测试-客户' || nn == '莱芜辰龙贸易有限公司') {
        return postRequest('api/order/inserts2', data);
    }
    return postRequest('api/order/inserts', data);
};

// 30.全部售后订单请求
export const getAfterSalesListRequest = (data) => {
    return postRequest('api/after/sales/list', data);
};


export const getSalesReturnListRequest = (data) => {
    return postRequest('api/sales/return/list', data);
};

// 31.全部发货中订单请求
export const allSendingOrderListRequest = (data) => {
    return postRequest('api/order/indelivery/list2', data);
};

// 32.全部已发货订单请求
export const allSentOrderListRequest = (data) => {
    return postRequest('api/order/delivered/list2', data);
};

// 33.订单详情请求
export const orderDetailRequest = (url) => {
    return getRequest('api/order/' + url);
};




export const ckListRequest = () => {
    return getRequest('api/select/stock');
};


// 34.可选快递列表请求
export const kdListRequest = () => {
    return getRequest('api/select/delivery');
};

// 35.快递选择请求
export const kdChooseRequest = (data) => {
    return postRequest('api/update/delivery', data);
};

// 36.开票请求
export const openTicketRequest2 = (url) => {
    return getRequest('api/insert/invoice/' + url);
};

export const openTicketRequest = (data) => {
    return postRequest('api/update/invoice', data);
};

// 37.已导入订单详情请求
export const interOrderDetailRequest2 = (url) => {
    return getRequest('api/order/an/' + url);
};

export const interOrderDetailRequest = (data) => {
    return postRequest('api/order/list', { batchId: data });
};

export const interOrderDetail2Request = (data) => {
    return postRequest('api/order/list', { batchId: data, status: 0 });
};

// 38.支付请求
export const payRequest = (data) => {
    return postRequest('api/batch/pay', data);
};

export const batchFileRequest = (data) => {
    return postRequest('api/batch/edit', data);
};

// 40.购物车列表请求
export const getCartListRequest = (data) => {
    return postRequest('api/cart/list', data);
};

// 41.购物车内商品删除请求
export const shoppingCarGoodsDeteleRequest = (data) => {
    return postRequest('api/delete/cart/goods', data);
};

// 41.购物车内商品数量调整请求
export const shoppingCarGoodsNumberRequest = (data) => {
    return postRequest('api/update/goodnums/cart', data);
};

// 41.购物车确认生成订单请求
export const shoppingCarSubmitMakeOrderRequest = (data) => {
    return postRequest('api/order/an', data);
};

// 42.购物车导入多收货地址请求
export const shoppingCarIntoMuchAddressRequest = (data) => {
    return postRequest('api/import/cart/order', data);
};

// 43.地址切割请求
export const addressCutRequest = (data) => {
    return postRequest('api/cart/splitAddress2', data);
};

// 44.确认充值请求
export const submitPayRequest = (data) => {
    return postRequest('api/financial/onlinePay/add', data);
};

// 45.支付单据详情请求
export const payStatusRequest = (data) => {
    return postRequest('api/financial/onlinePay/info', data);
};

// 46.取消导入订单中子订单请求
export const cacelOrderSonRequest = (url) => {
    return getRequest('api/delete/order/an/detail/' + url);
};

// 47.月结账单订单列表
export const orderEveryRequest = (url) => {
    return getRequest('api/accountStatement/detail/' + url);
};

export const editOrderGoodsPriceRequest = (data) => {
    return postRequest('api/order/goodsPriceEdit', data);
};

// 获取组合列表
export const setmealListRequest = (data) => {
    return postRequest('api/setmeal/list', data);
};
// 添加组合信息
export const addSetmealRequest = (data) => {
    return postRequest('api/setmeal/add', data);
};
// 组合信息修改
export const editSetmealRequest = (data) => {
    return postRequest('api/setmeal/edit', data);
};
// 删除组合
export const delSetmealRequest = (data) => {
    return postRequest('api/setmeal/delete', data);
};

export const getSetmealGoodsListRequest = (data) => {
    return postRequest('api/setmeal/goods/list', data);
};

export const addSetmealGoodsRequest = (data) => {
    return postRequest('api/setmeal/goods/add', data);
};
export const editSetmealGoodsRequest = (data) => {
    return postRequest('api/setmeal/goods/edit', data);
};

export const delSetmealGoodsRequest = (data) => {
    return postRequest('api/setmeal/goods/delete', data);
};
// 获取客户信息
export const getCustomerInfoRequest = (data) => {
    return postRequest2('getCustomerInfo', data);
};

export const getArticleTypeListRequest = (data) => {
    return postRequest('api/article/type/list', data);
};

export const getArticleListRequest = (data) => {
    return postRequest('api/article/list', data);
};


export const getAddresslListRequest = (data) => {
    return postRequest('api/address/list', data);
};
// 添加组合信息
export const addAddressRequest = (data) => {
    return postRequest('api/address/add', data);
};
// 组合信息修改
export const editAddressRequest = (data) => {
    return postRequest('api/address/edit', data);
};
// 删除组合
export const delAddressRequest = (data) => {
    return postRequest('api/address/delete', data);
};

//获取开票列表
export const getInvoiceListRequest = (data) => {
    return postRequest('api/invoice/list', data);
};

export const delInvoiceRequest = (url) => {
    return getRequest('api/invoice/delete/' + url);
};

export const getOfflinePayListRequest = (data) => {
    return postRequest('api/pay/offline/list', data);
};

export const getFundChangeRequest = (data) => {
    return postRequest('api/fund/change/list', data);
};

export const getBatchInfoRequest = (id) => {
    return getRequest('api/batch/' + id);
};

export const getBrandListRequest = (data) => {
    return postRequest('api/brand/list', data);
};

export const getClassifyListRequest = (data) => {
    return postRequest('api/classify/list', data);
};

// 退出登录
export const loginOutCustomerRequest = () => {
    return getRequest('loginOutCustomer');
};

